// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isEmailIpWarmingAppGroupIdIpCountResult = objectOf({
  ip_count: number,
});
